import { squabPresentation, squabTime } from "@/lib/squab";
import "./SquabCard.css";

export function SquabCard({ battle, busy = false, onPlay, onRematch, onChallenge }) {
  const view = squabPresentation(battle);
  const results = battle?.finished && battle.is_participant && battle.challenger_seconds != null && battle.opponent_seconds != null;
  const canAccept = !battle || (battle.can_play && !battle.finished);
  return <article className={`squab-card squab-card--${view.kind}`} data-testid="squab-card">
    <p className="squab-card-brand">{view.brand}</p>
    <h1 className="squab-card-heading">{view.heading}</h1>
    {view.body && <p className="squab-card-body">{view.body}</p>}
    {view.prompt && <p className="squab-card-prompt">{view.prompt}</p>}
    {battle && <div className="squab-card-personal">
      <p className="squab-card-title">{battle.title}</p>
      <p className="squab-card-players">{battle.challenger_name} vs {battle.opponent_name || "a homie"}</p>
    </div>}
    {results && <div className="squab-card-results" data-testid="squab-results">
      <p className="squab-card-outcome">{battle.winner === "tie" ? "IT'S A TIE!" : `${battle.winner_name} WINS!`}</p>
      <dl className="squab-card-times">
        <div><dt>{battle.challenger_name}</dt><dd>{squabTime(battle.challenger_seconds)}</dd></div>
        <div><dt>{battle.opponent_name}</dt><dd>{squabTime(battle.opponent_seconds)}</dd></div>
      </dl>
      {battle.head_to_head && <div className="squab-card-record" role="group" aria-label="Lifetime head-to-head record" data-testid="squab-record">
        <p className="squab-card-record-label">YOU vs {battle.head_to_head.opponent_name || "THE HOMIE"}</p>
        <p className="squab-card-record-total">{battle.head_to_head.wins} {battle.head_to_head.wins === 1 ? "WIN" : "WINS"} • {battle.head_to_head.losses} {battle.head_to_head.losses === 1 ? "LOSS" : "LOSSES"}</p>
      </div>}
      {battle.trash_talk && <p className="squab-card-note">{battle.trash_talk.replace(/YOU (?:SERVED|COOKED) HIM!/gi, "YOU BODIED FAM!")}</p>}
    </div>}
    {battle && !battle.finished && <p className="squab-card-note">Times stay hidden until both players finish.</p>}
    {view.kind === "challenge" ? <button type="button" className="squab-card-button" onClick={onChallenge}>SQUAB WIT DA HOMIE</button>
      : results && battle.can_rematch ? <button type="button" className="squab-card-button" disabled={busy} onClick={onRematch}>{busy ? "…" : view.kind === "tie" ? "Rematch" : "RUN IT BACK! 🔥"}</button>
      : canAccept ? <button type="button" className="squab-card-button" disabled={busy} onClick={onPlay}>{busy ? "…" : "ACCEPT THE SMOKE 💨"}</button> : null}
  </article>;
}
